import BlockFormatting from './buttons/src/block-formatting.js';
import TextFont from './buttons/src/text-font.js';
import FontSize from './buttons/src/font-size.js';
import LineHeight from './buttons/src/line-height.js';
import Image from './buttons/src/image.js';
import ArtText from './buttons/src/art-text.js';
import Link from './buttons/src/link.js';
import Document from './buttons/src/document.js';
import Table from './buttons/src/table.js';
import Snippet from './buttons/src/snippet.js';
import Divider from './buttons/src/divider.js';
import HTML from './buttons/src/html.js';
import Color from './buttons/src/color.js';
import Layer from './buttons/src/layer.js';
import More from './buttons/src/more.js';
import Macros from './buttons/src/macros.js';


export default function Button (pGroup, pButtonStruct)
{
  const pThis = this;

  pThis.RenderComplete = BEditor.eventHandlers.createHandlers(pThis, { id: 'RenderComplete' });
  pThis.Dispose = BEditor.eventHandlers.createHandlers(pThis, { id: 'Dispose' });

  let i,
      eButton,
      eButtonBgX,
      eButtonBgY,
      eButtonText,
      eButtonContainer,
      eButtonIcon,
      eButtonFieldPreview,
      eButtonFieldName,
      eButtonArrowContainer,
      eButtonArrow,
      eButtonCover,
      closeDropdownTM;

  pThis.mouseOver = mouseOver;
  pThis.mouseOut = mouseOut;
  pThis.mouseDown = mouseDown;
  pThis.mouseUp = mouseUp;
  pThis.click = click;

  pThis.refreshState = refreshState;

  pThis.editorCloseDropdownTM = null;
  pThis.closeDropdown = closeDropdown;
  pThis.getDropdownState = getDropdownState;
  pThis.stopUnregEditor = pGroup.pToolbar.pThis.stopUnregEditorInstance;

  pThis.preInitBlockFormattingDropdownButton = (...args) => blockFormatting.preInitBlockFormattingDropdownButton(...args);
  pThis.setFormattingDropdownItemsClass = (...args) => blockFormatting.setFormattingDropdownItemsClass(...args);
  pThis.showHideFormattingDropdownOptionalItems = (...args) => blockFormatting.showHideFormattingDropdownOptionalItems(...args);
  pThis.preInitTextFontDropdownButton = (...args) => textFont.preInitTextFontDropdownButton(...args);
  pThis.preInitForeColorDropdownButton = (...args) => color.preInitForeColorDropdownButton(...args);
  pThis.preInitBackColorDropdownButton = (...args) => color.preInitBackColorDropdownButton(...args);
  pThis.setColorDropdownThemeColors = (...args) => color.setColorDropdownThemeColors(...args);

  let pAttribute =
  {
    name: pButtonStruct.name,
    type: pButtonStruct.type,
    id: pGroup.eGroup.id + '_' + pButtonStruct.name,
    fileURL: pButtonStruct.btnFileURL,
    fileWidth: pButtonStruct.btnFileWidth,
    fileHeight: pButtonStruct.btnFileHeight,
    icoFileURL: pButtonStruct.btnIcoFileURL,
    curIcoFileURL: pButtonStruct.btnCurIcoFileURL,
    bgFileURL: pButtonStruct.btnBgFileURL,
    curBgFileURL: pButtonStruct.btnCurBgFileURL,
    arrFileURL: pButtonStruct.btnArrFileURL,
    ddFileURL: pButtonStruct.ddBtnFileURL,
    ddBgFileURL: pButtonStruct.ddBtnBgFileURL,
    ddCurBgFileURL: pButtonStruct.ddBtnCurBgFileURL,
    doubleSize: pButtonStruct.doubleSize,
    icoOffsetX: pButtonStruct.icoOffsetX,
    state: pButtonStruct.state,
    visible: pButtonStruct.visible,
    left: pButtonStruct.btnLeft,
    width: pButtonStruct.btnSizeWidth,
    height: pButtonStruct.btnSizeHeight,
    icoUpNormal: pButtonStruct.btnIcoUpNormal,
    icoUpOver: pButtonStruct.btnIcoUpOver,
    icoUpDisable: pButtonStruct.btnIcoUpDisable,
    icoDownNormal: pButtonStruct.btnIcoDownNormal,
    icoDownOver: pButtonStruct.btnIcoDownOver,
    icoDownDisable: pButtonStruct.btnIcoDownDisable,
    title: pButtonStruct.title,
    disabledTitle: pButtonStruct.disabledTitle,
    curTitle: pButtonStruct.curTitle,
    command: pButtonStruct.command,
    includedCommands: pButtonStruct.includedCommands,
    isStackable: pButtonStruct.isStackable,
    dropdownGroupType: pButtonStruct.dropdownGroupType,
    openerButtonName: pButtonStruct.openerButtonName,
    openerButton: pGroup.pToolbar.pThis.getButtonByName(pButtonStruct.openerButtonName),
    model: pButtonStruct.model,
    parameters: pButtonStruct.parameters
  };

  pThis.id = pAttribute.id;
  pThis.isMouseDown = false;

  const pButton =
  {
    pGroup,
    pThis,

    get pAttribute() { return pAttribute; },
    get eButton() { return eButton; },
    get eButtonText() { return eButtonText; },
    set eButtonText(v) { eButtonText = v; },

    initDropdownComponents,
    closeDropdown,
    restoreEditorRange
  };

  const blockFormatting = new BlockFormatting(pButton);
  const textFont = new TextFont(pButton);
  const fontSize = new FontSize(pButton);
  const lineHeight = new LineHeight(pButton);
  const image = new Image(pButton);
  const artText = new ArtText(pButton);
  const link = new Link(pButton);
  const document = new Document(pButton);
  const table = new Table(pButton);
  const snippet = new Snippet(pButton);
  const divider = new Divider(pButton);
  const html = new HTML(pButton);
  const color = new Color(pButton);
  const layer = new Layer(pButton);
  const more = new More(pButton);
  const macros = new Macros(pButton);

  const preInitDropdownList =
  {
    'openBlockFormattingDropdown': [ blockFormatting.createBlockFormattingButton, blockFormatting.preInitBlockFormattingDropdownButton ],
    'openTextFontDropdown': [ textFont.createTextFontDropdownButton, textFont.preInitTextFontDropdownButton ],
    'openFontSizeDropdown': [ fontSize.createFontSizeDropdownButton, fontSize.preInitFontSizeDropdownButton ],
    'openLineHeightDropdown': [ lineHeight.createLineHeightDropdownButton, lineHeight.preInitLineHeightDropdownButton ],
    'openForeColorDropdown': [ color.preInitForeColorDropdownButton ],
    'openBackColorDropdown': [ color.preInitBackColorDropdownButton ],
    'openLinkDropdown': [ link.preInitLinkDropdownButton ],
    'openLayerDropdown': [ layer.preInitLayerDropdownButton ],
    'openTableDropdown': [ table.preInitTableDropdownButton ],
    'openMoreLocalDropdown': [ more.preInitMorePublicDropdownButton ]
  };

  const preInitDialogList =
  {
    'openInsertImageDialog': image.preInitInsertImageButton,
    'openInsertArtTextDialog': artText.preInitInsertArtTextButton,
    'openInsertLinkDialog': link.preInitInsertLinkButton,
    'openInsertDocumentDialog': document.preInitInsertDocumentButton,
    'openEditDocumentDialog': document.preInitEditDocumentButton,
    'openInsertTableDialog': table.preInitInsertTableButton,
    'openInsertSnippetDialog': snippet.preInitInsertSnippetButton,
    'openEditHTMLDialog': html.preInitEditHTMLButton,
    'insertHR': divider.preInitInsertDividerButton,
    'openInsertEmailMacrosDialog': macros.preInitInsertEmailMacrosDialogButton
  };

  createSingleButton();


  function createSingleButton()
  {
    if (pAttribute.isMultiButton)
    {
      createSingleButtonDo();
    }
    else
    {
      createSingleButtonDo();
    }

    if (pAttribute.type === 'DropdownButton')
    {
      if (pAttribute.command in preInitDropdownList)
      {
        preInitDropdownList[pAttribute.command].forEach(item => item());
      }
    }
    else if (pAttribute.type === 'DialogButton' && !pAttribute.parameters.isLazyLoad)
    {
      if (pAttribute.command in preInitDialogList)
      {
        preInitDialogList[pAttribute.command]();
      }
    }

    pThis.extension = BEditor.ExtensionsManager.createButtonExtension(pAttribute.name, pThis);
  }


  function createSingleButtonDo()
  {
    eButton = pGroup.pToolbar.tDoc.createElement('DIV');

    eButton.id = pAttribute.id;
    eButton.title = pAttribute.title;

    if (!pGroup.pAttribute.dropdownGroup)
    {
      eButton.style.position = 'absolute';
      eButton.style.left = pAttribute.left + 'px';
      eButton.style.top = '0px';
      eButton.style.zIndex = '3';
    }
    else
    {
      eButton.style.position = 'relative';
      eButton.style.zIndex = '3';
    }

    eButton.style.width = pAttribute.width + 'px';
    eButton.style.height = pAttribute.height + 'px';
    eButton.style.overflow = 'hidden';

    eButtonBgX = (-pAttribute.icoOffsetX);
    eButtonBgY = (-pAttribute.height * pAttribute['ico' + pAttribute.state]);
    eButton.style.background = 'transparent url(' + pAttribute.fileURL + ') ' + eButtonBgX + 'px ' + eButtonBgY + 'px no-repeat';

    eButton.style.cursor = (pAttribute.state.indexOf('Disable') === -1) ? 'pointer' : 'default';

    pGroup.eGroup.appendChild(eButton);

    BEditor.domHandlers.addHandlers(
    [
      [
        eButton,
        [
          ['mouseover', mouseOver],
          ['mouseout', mouseOut],
          ['mousedown', pGroup.pToolbar.pThis.toolbarOnClick],
          ['mousedown', mouseDown],
          ['mouseup', pGroup.pToolbar.pThis.toolbarOnClick],
          ['mouseup', mouseUp],
          ['click', pGroup.pToolbar.pThis.toolbarOnClick],
          ['click', click],
          ['dragstart', function() { return false; }]
        ]
      ]
    ]);

    eButton.ondragstart = function() { return false; }
  }


  function mouseOver (e)
  {
    BEditor.domHandlers.stopEvent(e, window);

    if (!pAttribute.doubleSize)
    {
      if (pAttribute.state === 'UpNormal')
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoUpOver);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        pAttribute.state = 'UpOver';
      }
      else if (pAttribute.state === 'DownNormal')
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoDownOver);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        pAttribute.state = 'DownOver';
      }
    }
    else
    {
      if (pAttribute.state === 'UpNormal')
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoUpOver);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        pAttribute.state = 'UpOver';
      }
      else if (pAttribute.state === 'DownNormal')
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoDownOver);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        pAttribute.state = 'DownOver';
      }
    }

    if (pAttribute.state === 'UpOver' || pAttribute.state === 'DownOver')
    {
      eButton.style.zIndex = 7;
    }
  }


  function mouseOut (e)
  {
    BEditor.domHandlers.stopEvent(e, window);

    if (!pAttribute.doubleSize)
    {
      if (pAttribute.state === 'UpOver')
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoUpNormal);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        pAttribute.state = 'UpNormal';
      }
      else if (pAttribute.state === 'DownOver')
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoDownNormal);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        pAttribute.state = 'DownNormal';
      }
    }
    else
    {
      if (pAttribute.state === 'UpOver')
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoUpNormal);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        pAttribute.state = 'UpNormal';
      }
      else if (pAttribute.state === 'DownOver')
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoDownNormal);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        pAttribute.state = 'DownNormal';
      }
    }

    if (pAttribute.state === 'UpNormal')
    {
      eButton.style.zIndex = 3;
    }
    else if (pAttribute.state === 'DownNormal')
    {
      eButton.style.zIndex = 5;
    }
  }


  const addInputTextHandlers = () =>
  {
    eButtonText.addEventListener('touchstart', BEditor.domHandlers.stopEventBubbling, false);
    eButtonText.addEventListener('touchend', BEditor.domHandlers.stopEventBubbling, false);
    eButtonText.addEventListener('mousedown', BEditor.domHandlers.stopEventBubbling, false);
    eButtonText.addEventListener('mouseup', BEditor.domHandlers.stopEventBubbling, false);
    eButtonText.addEventListener('click', BEditor.domHandlers.stopEventBubbling, false);
  };


  const removeInputTextHandlers = () =>
  {
    eButtonText.removeEventListener('touchstart', BEditor.domHandlers.stopEventBubbling, false);
    eButtonText.removeEventListener('touchend', BEditor.domHandlers.stopEventBubbling, false);
    eButtonText.removeEventListener('mousedown', BEditor.domHandlers.stopEventBubbling, false);
    eButtonText.removeEventListener('mouseup', BEditor.domHandlers.stopEventBubbling, false);
    eButtonText.removeEventListener('click', BEditor.domHandlers.stopEventBubbling, false);
  };


  let isOpenInputButtonTextDropdownMobileFreeze = false;

  function mouseDown (e)
  {
    BEditor.domHandlers.stopEvent(e, window);

    if (pGroup.pToolbar.pEditor)
    {
      pGroup.pToolbar.pEditor.hideAutoCleaningMessage();
      pGroup.pToolbar.pEditor.closeDropdown();
    }

    pThis.isMouseDown = true;
    pGroup.pToolbar.pThis.isMouseDown = true;

    if ((pGroup.pToolbar.pEditor || pThis.extension) && pAttribute.state !== 'UpDisable' && pAttribute.state !== 'DownDisable')
    {
      eButtonBgY = (-pAttribute.height * pAttribute.icoDownOver);
      eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';

      if (pAttribute.type === 'MoreButtonsDropdown')
      {
        openButtonsDropdown();
      }
      else if (pAttribute.type === 'DropdownButton')
      {
        if (pAttribute.command === 'openFontSizeDropdown' || pAttribute.command === 'openLineHeightDropdown')
        {
          if (pAttribute.Dropdown.getState())
          {
            eButtonText.style.borderColor = '#F5F5F5';
            eButtonText.style.backgroundColor = '#F5F5F5';
            eButtonText.style.cursor = 'pointer';
            removeInputTextHandlers();
            pAttribute.eButtonText.blur();
          }
          else
          {
            eButtonText.disabled = false;
            eButtonText.style.borderColor = '#ABABAB';
            eButtonText.style.backgroundColor = '#FFFFFF';
            eButtonText.style.cursor = 'text';
            addInputTextHandlers();

            if (BEditor.device.isMobile || BEditor.browser.isEdge)
            {
              isOpenInputButtonTextDropdownMobileFreeze = true;
              setTimeout(function () { isOpenInputButtonTextDropdownMobileFreeze = false; }, 100);
            }
          }
        }

        if (pGroup.pToolbar.pEditor)
        {
          pGroup.pToolbar.pEditor.execCommand(pThis, pAttribute.command);
        }
        else if (pThis.extension)
        {
          try
          {
            pThis.extension.click();
          }
          catch (err) {}
        }
      }
    }

    pGroup.pToolbar.pThis.stopUnregEditorInstance();
    setTimeout(pGroup.pToolbar.pThis.stopUnregEditorInstance, 10);
  }


  function mouseUp (e)
  {
    BEditor.domHandlers.stopEvent(e, window);

    pThis.isMouseDown = false;
    pGroup.pToolbar.pThis.isMouseDown = false;

    if ((pGroup.pToolbar.pEditor || pThis.extension) && pAttribute.state !== 'UpDisable' && pAttribute.state !== 'DownDisable')
    {
      if (pAttribute.state === 'UpNormal' || pAttribute.state === 'UpOver')
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoUpOver);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        pAttribute.state = 'UpOver';
      }
    }

    pGroup.pToolbar.pThis.stopUnregEditorInstance();
    setTimeout(pGroup.pToolbar.pThis.stopUnregEditorInstance, 10);
  }


  function click (e)
  {
    BEditor.domHandlers.stopEvent(e, window);

    if ((pGroup.pToolbar.pEditor || pThis.extension) && pAttribute.state !== 'UpDisable' && pAttribute.state !== 'DownDisable')
    {
      if (pAttribute.type !== 'DropdownButton' && pAttribute.type !== 'MoreButtonsDropdown')
      {

        if (pGroup.pToolbar.pEditor)
        {

          pGroup.pToolbar.pEditor.execCommand(pThis, pAttribute.command);
        }
        else if (pThis.extension)
        {
          pThis.extension.click();
        }
      }
    }

    pThis.refreshState();
  }


  function refreshState (sender, args)
  {
    let currentBlockStyleIndex;

    if (pThis.isMouseDown || (BEditor.browser.isEdge && pButton.pGroup.pToolbar.isInputFocus))
    {
      return false;
    }

    if (pGroup.pToolbar.pEditor || pThis.extension)
    {
      if (BEditor.browser.isIE && sender === 'BonaDropdown' && pGroup.pToolbar.pEditor)
      {
        pGroup.pToolbar.pEditor.focus(true);
      }

      if ((pGroup.pToolbar.pEditor && pGroup.pToolbar.pEditor.queryCommandEnabled(pThis, pAttribute.command)) || (pThis.extension && pThis.extension.getIsExists() && pThis.extension.getIsEnabled()) || pAttribute.type === 'MoreButtonsDropdown')
      {
        if (!pAttribute.doubleSize && pAttribute.type !== 'MoreButtonsDropdown')
        {
          if ((pGroup.pToolbar.pEditor && pGroup.pToolbar.pEditor.queryCommandState(pThis, pAttribute.command)) || (pAttribute.Dropdown && pAttribute.Dropdown.getState()) || (pThis.extension && pThis.extension.getState()))
          {
            eButtonBgY = (-pAttribute.height * pAttribute.icoDownNormal);
            eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
            eButton.style.cursor = 'pointer';
            pAttribute.state = 'DownNormal';
          }
          else
          {
            eButtonBgY = (-pAttribute.height * pAttribute.icoUpNormal);
            eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
            eButton.style.cursor = 'pointer';
            pAttribute.state = 'UpNormal';
          }

          eButton.title = pAttribute.title;

          if (pAttribute.command === 'openBlockFormattingDropdown')
          {
            eButtonText.style.color = '#4A4A4A';
            currentBlockStyleIndex = pGroup.pToolbar.pEditor.getCurrentBlockFormatting(pAttribute.parameters.styleIdList);
            eButtonText.innerHTML = ((currentBlockStyleIndex !== null && !(pAttribute.parameters.isOptionalItemHided && pAttribute.parameters.styles[currentBlockStyleIndex].isOptional)) ? pAttribute.parameters.styles[currentBlockStyleIndex]['name'] : 'Normal');
          }
          else if (pAttribute.command === 'openTextFontDropdown')
          {
            eButtonText.style.color = '#4A4A4A';
            let currentTextFont = pGroup.pToolbar.pEditor.getCurrentTextFont() || '';
            eButtonText.innerHTML = currentTextFont.charAt(0).toUpperCase() + currentTextFont.slice(1);
          }
          else if (pAttribute.command === 'openFontSizeDropdown' || pAttribute.command === 'openLineHeightDropdown')
          {
            if (!pAttribute.Dropdown.getState() && !isOpenInputButtonTextDropdownMobileFreeze)
            {
              eButtonText.disabled = false;
              eButtonText.style.borderColor = '#F5F5F5';
              eButtonText.style.backgroundColor = '#F5F5F5';
              eButtonText.style.color = '#4A4A4A';
              eButtonText.style.cursor = 'pointer';
              eButtonText.value = ((pAttribute.command === 'openFontSizeDropdown') ? pGroup.pToolbar.pEditor.getCurrentFontSize() : pGroup.pToolbar.pEditor.getCurrentLineHeight());
              removeInputTextHandlers();
              pAttribute.eButtonText.blur();
            }
          }
        }
        else if (pAttribute.type === 'MoreButtonsDropdown')
        {
          eButton.style.cursor = 'pointer';

          if (pAttribute.Dropdown && pAttribute.Dropdown.getState())
          {
            eButtonBgY = (-pAttribute.height * pAttribute.icoDownNormal);
            eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
            pAttribute.state = 'DownNormal';
          }
          else
          {
            eButtonBgY = (-pAttribute.height * pAttribute.icoUpNormal);
            eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
            pAttribute.state = 'UpNormal';
          }
        }
        else if (pAttribute.command === 'openContentModulesDropdown')
        {
          if ((pGroup.pToolbar.pEditor && pGroup.pToolbar.pEditor.queryCommandState(pThis, pAttribute.command)) || (pThis.extension && pThis.extension.getState()))
          {
            eButtonContainer.style.backgroundPosition = '-83px -47px';
            eButtonIcon.style.top = "-40px";
            eButtonFieldName.innerHTML = pAttribute.curTitle;
            eButtonArrowContainer.style.display = 'none';
            eButtonFieldName.style.color = '#000000';
            eButtonArrow.style.top = '-76px';
            eButtonCover.style.cursor = 'pointer';
            pAttribute.state = 'DownNormal';
          }
          else
          {
            eButtonContainer.style.backgroundPosition = '-83px 0px';
            eButtonIcon.style.top = "2px";
            eButtonFieldName.innerHTML = pAttribute.title;
            eButtonArrowContainer.style.display = 'block';
            eButtonFieldName.style.color = '#000000';
            eButtonArrow.style.top = '-76px';
            eButtonCover.style.cursor = 'pointer';
            pAttribute.state = 'UpNormal';
          }
        }
        else
        {
          if ((pGroup.pToolbar.pEditor && pGroup.pToolbar.pEditor.queryCommandState(pThis, pAttribute.command)) || (pAttribute.Dropdown && pAttribute.Dropdown.getState()) || (pThis.extension && pThis.extension.getState()))
          {
            eButtonBgY = (-pAttribute.height * pAttribute.icoDownNormal);
            eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
            eButton.style.cursor = 'pointer';
            pAttribute.state = 'DownNormal';
          }
          else
          {
            eButtonBgY = (-pAttribute.height * pAttribute.icoUpNormal);
            eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
            eButton.style.cursor = 'pointer';
            pAttribute.state = 'UpNormal';
          }

          eButton.title = pAttribute.title;
        }
      }
      else
      {
        if (!pAttribute.doubleSize)
        {
          eButtonBgY = (-pAttribute.height * pAttribute.icoUpDisable);
          eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
          eButton.style.cursor = 'default';

          if (pAttribute.disabledTitle != null)
          {
            eButton.title = pAttribute.disabledTitle;
          }

          if (pAttribute.type === 'DropdownButton')
          {
            closeDropdown();

            if (pAttribute.command === 'openTextFontDropdown')
            {
              eButtonText.style.color = '#C1C1C1';
              eButtonText.innerHTML = pAttribute.title;
            }
            else if (pAttribute.command === 'openFontSizeDropdown'|| pAttribute.command === 'openLineHeightDropdown')
            {
              eButtonText.disabled = true;
              eButtonText.style.borderColor = '#F5F5F5';
              eButtonText.style.backgroundColor = '#F5F5F5';
              eButtonText.style.color = '#C1C1C1';
              eButtonText.value = 'Size';
              eButtonText.value = ((pAttribute.command === 'openFontSizeDropdown') ? 'Size' : 'Line');
              removeInputTextHandlers();
              pAttribute.eButtonText.blur();
            }
          }
        }
        else
        {
          eButtonBgY = (-pAttribute.height * pAttribute.icoUpDisable);
          eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
          eButton.style.cursor = 'default';

          if (pAttribute.disabledTitle != null)
          {
            eButton.title = pAttribute.disabledTitle;
          }
        }

        pAttribute.state = 'UpDisable';
      }
    }
    else
    {
      if (!pAttribute.doubleSize)
      {
        eButtonBgY = (-pAttribute.height * pAttribute.icoUpDisable);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        eButton.style.cursor = 'default';

        if (pAttribute.type === 'DropdownButton')
        {
          if (pAttribute.command === 'openBlockFormattingDropdown' || pAttribute.command === 'openTextFontDropdown')
          {
            eButtonText.style.color = '#C1C1C1';
            eButtonText.innerHTML = pAttribute.title;
          }
          else if (pAttribute.command === 'openFontSizeDropdown'|| pAttribute.command === 'openLineHeightDropdown')
          {
            eButtonText.disabled = true;
            eButtonText.style.borderColor = '#F5F5F5';
            eButtonText.style.backgroundColor = '#F5F5F5';
            eButtonText.style.color = '#C1C1C1';
            eButtonText.value = ((pAttribute.command === 'openFontSizeDropdown') ? 'Size' : 'Line');
            removeInputTextHandlers();
            pAttribute.eButtonText.blur();
          }
        }
      }
      else
      {
        if (pAttribute.command === 'openContentModulesDropdown' && pAttribute.state === 'DownNormal')
        {
          eButtonContainer.style.backgroundPosition = '-83px 0px';
          eButtonIcon.style.top = "2px";
          eButtonFieldName.innerHTML = pAttribute.title;
          eButtonArrowContainer.style.display = 'block';
        }

        eButtonBgY = (-pAttribute.height * pAttribute.icoUpDisable);
        eButton.style.backgroundPosition = eButtonBgX + 'px ' + eButtonBgY + 'px';
        eButton.style.cursor = 'default';
      }

      pAttribute.state = 'UpDisable';
    }

    if (pAttribute.state === 'UpNormal')
    {
      eButton.style.zIndex = 3;
    }
    else if (pAttribute.state === 'DownNormal')
    {
      eButton.style.zIndex = 5;
    }
    else if (pAttribute.state === 'UpOver' || pAttribute.state === 'DownOver')
    {
      eButton.style.zIndex = 7;
    }
    else
    {
      eButton.style.zIndex = 1;
    }
  }


  this.getAttribute = function(attName)
  {
    if (attName && pAttribute[attName])
    {
      return pAttribute[attName];
    }
    else
    {
      return null;
    }
  };


  this.setAttribute = function(attName, attValue)
  {
    pAttribute[attName] = attValue;
  };


  this.getPanelWindow = function()
  {
    return pGroup.pToolbar.tWindow;
  };


  this.getDialog = function()
  {
    if (!pAttribute.Dialog)
    {
      if (preInitDialogList[pAttribute.command])
      {
        preInitDialogList[pAttribute.command]();
      }
    }

    return ((pAttribute.Dialog) ? pAttribute.Dialog : null);
  };


  this.getDropdown = function()
  {
    return ((pAttribute.Dropdown) ? pAttribute.Dropdown : null);
  };


  this.getButtonXY = function()
  {
    const eButtonCoords = BEditor.dimensions.getElementAbsXY(eButton, pGroup.pToolbar.tWindow),
          isPositionFixed = (pGroup.pToolbar.floatingToolbar && pGroup.pToolbar.floatingToolbar.isPositionFixed);

    let eButtonLeft,
        eButtonTop;

    if (BEditor.AdminPanel)
    {
      eButtonLeft = isPositionFixed ? eButtonCoords.X : eButtonCoords.deltaScrollX;
      eButtonTop = isPositionFixed ? eButtonCoords.Y : eButtonCoords.deltaScrollY;
    }
    else
    {
      eButtonLeft = isPositionFixed ? eButtonCoords.X + BEditor.window.getScrollLeft() : eButtonCoords.X;
      eButtonTop = isPositionFixed ? eButtonCoords.Y * 2 + Math.abs(eButtonCoords.deltaScrollY) : eButtonCoords.Y;
    }

    return [eButtonLeft, eButtonTop, eButtonCoords.width, eButtonCoords.height, isPositionFixed];
  };


  function openButtonsDropdown()
  {
    if (!pGroup.pToolbar.pThis.getEditorInstance() || !pAttribute.Dropdown)
    {
      return false;
    }

    if (pAttribute.Dropdown.getState())
    {
      closeDropdown(pAttribute.Dropdown);
    }
    else
    {
      pAttribute.Dropdown.openDropdown(closeDropdown, closeDropdown, closeDropdownWait, stopCloseDropdown);
    }
  }


  function closeDropdownWait()
  {
    if (!pGroup.pToolbar.pThis.getEditorInstance() || !pAttribute.Dropdown)
    {
      return false;
    }

    if (closeDropdownTM) clearTimeout(closeDropdownTM);

    closeDropdownTM = setTimeout(function()
    {
      if (pAttribute.Dropdown.getState())
      {
        closeDropdown();
      }
    }, 333);
  }


  function stopCloseDropdown()
  {
    if (closeDropdownTM) clearTimeout(closeDropdownTM);
  }


  function closeDropdown(isReal)
  {
    if (closeDropdownTM) clearTimeout(closeDropdownTM);

    if (pAttribute.Dropdown && pAttribute.Dropdown.getState())
    {
      pAttribute.Dropdown.closeDropdown();
    }

    if (isReal)
    {
      pGroup.pToolbar.pEditor.setIsDropdownOpen(false);
    }
  }


  function restoreEditorRange (sender, args)
  {
    if (!sender)
    {
      restoreEditorRangeDo(true);
    }
    else
    {
      restoreEditorRangeDo(true);
    }
  }


  function restoreEditorRangeDo (isImmediate)
  {
    if ((!getDropdownState() || isImmediate) && !BonaDialog.isDialogOpened && pGroup.pToolbar.pEditor)
    {
      pGroup.pToolbar.pEditor.focus();
      pGroup.pToolbar.pEditor.restoreEditorRange();
    }
  }


  function getDropdownState()
  {
    return ((pAttribute.Dropdown) ? pAttribute.Dropdown.getState() : null);
  }


  function initDropdownComponents (id, initLen, initDropdown)
  {
    const itemsContainerId = id || 'idItemsContainer_',
          dropdown = initDropdown || pAttribute.Dropdown,
          len = initLen || pAttribute.parameters.dropdownItemsLenght;

    let itemsContainer,
        itemsContainerHeight,
        itemCover,
        itemArrow,
        scrollablePanelContainer;

    if (dropdown.isObjValid)
    {
      for (i = 0; i < len; i++)
      {
        itemsContainer = dropdown.get$(itemsContainerId + i);
        itemsContainerHeight = itemsContainer.offsetHeight;
        itemCover = itemsContainer.querySelector('[id^=idItem]');
        itemCover.style.height = itemsContainerHeight + 'px';
        itemArrow = itemsContainer.querySelector('[id^=idArrow]');

        if (itemArrow)
        {
          itemArrow.style.top = Math.floor((itemsContainerHeight - itemArrow.offsetHeight) / 2) + 'px';
        }
      }

      scrollablePanelContainer = dropdown.getScrollablePanelContainer();

      if (scrollablePanelContainer)
      {
        scrollablePanelContainer.style.backgroundColor = '#F5F5F5';
      }

      if (pGroup.pToolbar.isLocalToolbar)
      {
        BEditor.LocalToolbarDropdowns.push({ 'dropdown': dropdown, 'handlerShowed': pThis.refreshState, 'handlerHidden': restoreEditorRange});
      }

      dropdown.DropDownShowed.addHandler(pThis.refreshState);
      dropdown.DropDownHidden.addHandler(restoreEditorRange);
    }
    else
    {
      setTimeout(((id != null || initLen != null || initDropdown != null) ? function () { initDropdownComponents(id, initLen, initDropdown); } : initDropdownComponents), 137);
    }
  }


  this.regEditorInstance = function()
  {
    if (pGroup.pToolbar.pEditor && eButtonFieldPreview && pAttribute.Dropdown)
    {
      eButtonFieldPreview.id = pGroup.pToolbar.pEditor.getBodyId();
      eButtonFieldPreview.className = pGroup.pToolbar.pEditor.getBodyClass();
      pAttribute.Dropdown.setBodyIdAndClass(eButtonFieldPreview.id, eButtonFieldPreview.className);
    }
  };


  this.unregEditorInstance = function()
  {
    pThis.isMouseDown = false;

    if (!pGroup.pToolbar.pEditor && eButtonFieldPreview && pAttribute.Dropdown)
    {
      try
      {
        eButtonFieldPreview.id = '';
        eButtonFieldPreview.className = '';
        pAttribute.Dropdown.setBodyIdAndClass('', '');
      }
      catch (e) { }
    }
  };


  this.getButtonByName = function(buttonName)
  {
    return (pAttribute.name === buttonName) ? pThis : null;
  };
}